// Indonesian marketing copy shared by the SEO renderer (server) and the pages (client), so the
// HTML crawlers read and the page people see say the same thing.

export const SITE_COPY = {
  defaultTitle: "AI Class — Belajar n8n, AI Agent, Automation & SaaS",
  defaultDescription:
    "Kelas online, ebook, dan workflow siap pakai berbahasa Indonesia untuk n8n, AI agent, automation, dan membangun SaaS. Dipandu langsung oleh Aji Prakoso.",
  keywords:
    "n8n, tutorial n8n indonesia, ai agent, automation, workflow automation, saas, vibe coding, hermes, openclaw, kursus automation",
  tagline: "Belajar automation & AI dari praktisi.",
  blogTitle: "Blog — Tutorial n8n, AI Agent & Automation",
  blogDescription:
    "Tutorial praktis berbahasa Indonesia seputar n8n, AI agent, workflow automation, dan membangun SaaS dengan AI.",
} as const;

export const FAQ_ITEMS = [
  {
    question: "Apa saja yang bisa saya pelajari di AI Class?",
    answer:
      "Materi kami berfokus pada automation dan AI yang langsung bisa dipakai: workflow n8n, AI agent dan chatbot, integrasi API, hingga membangun aplikasi dan SaaS dengan bantuan AI (vibe coding). Semua dalam bahasa Indonesia dengan studi kasus nyata.",
  },
  {
    question: "Apa itu n8n dan kenapa perlu dipelajari?",
    answer:
      "n8n adalah platform workflow automation open-source untuk menghubungkan aplikasi dan mengotomasi pekerjaan berulang tanpa coding yang rumit. Dengan n8n Anda bisa membuat chatbot, integrasi pembayaran, laporan otomatis, dan AI agent yang menghemat waktu bisnis setiap hari.",
  },
  {
    question: "Apakah cocok untuk pemula atau non-IT?",
    answer:
      "Ya. Materi disusun bertahap dari dasar hingga lanjutan, dijelaskan step-by-step dalam bahasa Indonesia. Banyak peserta kami berasal dari latar belakang non-IT dan berhasil membangun automation pertamanya dalam 1–2 minggu.",
  },
  {
    question: "Apa itu AI agent dan bedanya dengan chatbot biasa?",
    answer:
      "AI agent tidak hanya menjawab pertanyaan, tetapi juga mengambil tindakan: membaca data, memanggil API, mengisi spreadsheet, atau mengirim notifikasi. Di AI Class Anda belajar merancang AI agent yang terhubung ke workflow n8n dan tool bisnis yang Anda pakai.",
  },
  {
    question: "Apa itu vibe coding?",
    answer:
      "Vibe coding adalah cara membangun aplikasi dengan bantuan AI: Anda menjelaskan apa yang diinginkan, AI membantu menulis kode, dan Anda fokus pada produk. Kami mengajarkannya lewat studi kasus membuat aplikasi dan SaaS dari nol.",
  },
  {
    question: "Bagaimana cara mengakses materi setelah membeli?",
    answer:
      "Masuk dengan akun Google yang emailnya sama dengan email pembelian, lalu buka menu Produk Saya. Semua materi bisa diakses seumur hidup, termasuk update materi di kemudian hari.",
  },
  {
    question: "Metode pembayaran apa yang tersedia?",
    answer:
      "Pembayaran bisa dengan QRIS (dari semua aplikasi e-wallet dan mobile banking, tanpa biaya tambahan) atau Virtual Account bank. Akses produk aktif otomatis begitu pembayaran berhasil.",
  },
] as const;
